import { DraggableRowsTable } from '@components/draggable-rows-table';
import { EntityType } from '@lib/deals';
import { Divider, Grid, Tooltip, Typography } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import React, { useCallback, useMemo, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Column } from 'react-table';
import styled from 'styled-components';
import {
    orange
} from '@material-ui/core/colors';
import BusinessIcon from '@material-ui/icons/Business';
import { EntitySearchMultiPartyC2P } from './entity-search-multi-party-c2p';

export const ScrollSectionTitle = ({ children, icon, subTitle, id }) => (
    <Grid container id={id} spacing={icon ? 2 : 0} alignItems="center">
      {icon && <Grid item>{icon}</Grid>}
      <Grid item>
        <Typography variant="h5">{children}</Typography>
        {subTitle && (
          <Typography color="textSecondary" variant="body2">
            {subTitle}
          </Typography>
        )}
      </Grid>
    </Grid>
  );

  export const C2PPersonSelector = ({deal, createDeal=false,})=>{
    const form = useFormContext();
  
    const [indexesPerson, setIndexesPerson] = useState(
      Array.from(Array(deal.associated_person.length), (_, i) => i)
    );
    const [counterPerson, setCounterPerson] = useState(deal.associated_person.length);
    const addPersons = useCallback((index) => {
      setIndexesPerson(prevIndexes => {
        return [...prevIndexes, counterPerson];
      });
      setCounterPerson(prevCounter => prevCounter + 1);
    }, [indexesPerson, counterPerson]);
    
    const onChangeDraggedRows = allRowsModified => {
      setIndexesPerson(allRowsModified.map(eachRow => eachRow.id));
    };
  
    const removePersons = useCallback(index => {
      setIndexesPerson(prevIndexes => {
        return [...prevIndexes.filter(item => item !== index)];
      });
    }, [deal]);
  
    const getRowId = React.useCallback((row: any, idx) => {
      return '' + row.id;
    }, []);
  
    const columns: Column<any>[] = useMemo(
      () => [
        {
          Header: 'Cell',
          id: 'cell',
          Cell: ({ row, idx }) => {
            const isRowDeletetable = row.original.deleteable;
            const index = row.original.id;
            const fieldName = `associated_person[${index}]`;
            return (
              <Controller
                name={fieldName}
                key={index}
                control={form.control}
                defaultValue={
                  deal.associated_person[index]
                    ? deal.associated_person[index]
                    : {
                        name: '',
                        type: EntityType.person,
                        vtr_id: '',
                        meta: null,
                        relation_type: 'person',
                        order_id: index + 1,
                      }
                }
                render={({ onChange }) => (
                  <PaddingBottomEntitySearch key={index}>
                    <EntitySearchMultiPartyC2P
                      label=""
                      fixedType={EntityType.person}
                      defaultValue={
                        deal.associated_person[index]
                          ? deal.associated_person[index]
                          : {
                              name: '',
                              type: EntityType.person,
                              vtr_id: '',
                              meta: null,
                              relation_type: 'person',
                              order_id: index + 1,
                            }
                      }
                      hideTypeSelect
                      clearable
                      onChange={onChange}
                      // changeBuyer={changeBuyer}
                      titleEditable
                      indexOfEntities={index}
                      removeDealEntities={removePersons}
                      isDealEntityRemovable={isRowDeletetable}
                      dealData={form.getValues()}
                      isDealEntityRequestCreatable={!createDeal}
                    />
                  </PaddingBottomEntitySearch>
                )}
              />
            );
          },
        },
      ],
      [deal.associated_person]
    );
  
    return <React.Fragment key="buyers">
    <Grid container justify="space-between" style={{ marginRight: '30px' }}>
      <Grid item>
        <ScrollSectionTitle
          id="deal-buyers"
          subTitle={'Associated person in the Relation'}
          icon={<BusinessIcon fontSize="large" style={{ color: orange[700] }} />}>
          Associated Person
        </ScrollSectionTitle>
      </Grid>
      <Grid item style={{ paddingRight: '20px', paddingBottom: '10px' }}>
        <Tooltip title="Add Person">
          <StyledFab onClick={addPersons} color="primary" aria-label="add" size="small">
            <AddIcon />
          </StyledFab>
        </Tooltip>
      </Grid>
    </Grid>
    <Divider />
    <br />
    <fieldset style={{ padding: '0.75em', backgroundColor: '#f5f5f5', border: 'none' }}>
      <DraggableRowsTableStyled
        getRowId={getRowId}
        onChange={onChangeDraggedRows}
        columns={columns}
        data={indexesPerson.map(idx => ({
          id: idx,
          deleteable: true,
        }))}
        stickyHeader
        size="small"
        hideHeaders
        showDragIcon={false}
        multiSectionName = {EntityType.person}
      />
    </fieldset>
  </React.Fragment>
  } 
  

export function C2PCompanySelector({ deal, createDeal = false}) {
    const form = useFormContext();
    const [indexesDealBuyers, setIndexesDealBuyers] = useState(
      Array.from(Array(deal?.buyers?.length), (_, i) => i)
    );
    
    const [counterDealBuyers, setCounterDealBuyers] = useState(deal?.buyers?.length);
    const addDealBuyers = useCallback(() => {
      setIndexesDealBuyers(prevIndexes => {
        return [...prevIndexes, counterDealBuyers];
      });
      setCounterDealBuyers(prevCounter => prevCounter + 1);
    }, [indexesDealBuyers, counterDealBuyers]);
    
    const removeDealBuyers = useCallback(index => {
      setIndexesDealBuyers(prevIndexes => {
        return [...prevIndexes.filter(item => item !== index)];
      });
      const watchOnBuyers = form.watch('buyers');
      watchOnBuyers
        .filter((x, idx) => idx !== index)
        .forEach((eachRow, idx) => {
          if (eachRow) eachRow['order_id'] = idx + 1;
        });
    }, [deal]);
  
    const onChangeDraggedRows = allRowsModified => {
      setIndexesDealBuyers(allRowsModified.map(eachRow => eachRow.id));
    };
  
    const getRowId = React.useCallback((row: any, idx) => {
      return '' + row.id;
    }, []);
  
    const columns: Column<any>[] = useMemo(
      () => [
        {
          Header: 'Cell',
          id: 'cell',
          // width: 200,
          Cell: ({ row, idx }) => {
            const isRowDeletetable = row.original.deleteable;
            const index = row.original.id;
            const fieldName = `buyers[${index}]`;
            return (
              <Controller
                name={fieldName}
                key={index}
                control={form.control}
                defaultValue={
                  deal.buyers[index]
                    ? deal.buyers[index]
                    : {
                        name: '',
                        type: EntityType.company,
                        vtr_id: '',
                        meta: null,
                        relation_type: 'buyer',
                        order_id: index + 1,
                      }
                }
                render={({ onChange }) => (
                  <PaddingBottomEntitySearch key={index}>
                    <EntitySearchMultiPartyC2P
                      label="Buyer"
                      fixedType={EntityType.company}
                      defaultValue={
                        deal.buyers[index]
                          ? deal.buyers[index]
                          : {
                              name: '',
                              type: EntityType.company,
                              vtr_id: '',
                              meta: null,
                              relation_type: 'buyer',
                              order_id: index + 1,
                            }
                      }
                      hideTypeSelect
                      clearable
                      onChange={onChange}
                      // changeBuyer={changeBuyer}
                      titleEditable
                      indexOfEntities={index}
                      removeDealEntities={removeDealBuyers}
                      isDealEntityRemovable={isRowDeletetable}
                      dealData={form.getValues()}
                      isDealEntityRequestCreatable={!createDeal}
                    />
                  </PaddingBottomEntitySearch>
                )}
              />
            );
          },
        },
      ],
      [deal.buyers]
    );
    return (
      <React.Fragment key="buyers">
        <Grid container justify="space-between" style={{ marginRight: '30px' }}>
          <Grid item>
            <ScrollSectionTitle
              id="deal-buyers"
              subTitle={'Company for the C2P Relation'}
              icon={<BusinessIcon fontSize="large" style={{ color: orange[700] }} />}>
              Company
            </ScrollSectionTitle>
          </Grid>
          {/* <Grid item style={{ paddingRight: '20px', paddingBottom: '10px' }}>
            <Tooltip title="Add Company">
              <StyledFab onClick={addDealBuyers} color="primary" aria-label="add" size="small">
                <AddIcon />
              </StyledFab>
            </Tooltip>
          </Grid> */}
        </Grid>
        <Divider />
        <br />
        <fieldset style={{ padding: '0.75em', backgroundColor: '#f5f5f5', border: 'none' }}>
          <DraggableRowsTableStyled
            getRowId={getRowId}
            onChange={onChangeDraggedRows}
            columns={columns}
            data={indexesDealBuyers.map(idx => ({
              id: idx,
              deleteable: indexesDealBuyers.length > 1,
            }))}
            stickyHeader
            size="small"
            hideHeaders
            showDragIcon={false}
          />
        </fieldset>
      </React.Fragment>
    );
  }

  const DraggableRowsTableStyled = styled(DraggableRowsTable)`
  & .MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeSmall {
    padding-bottom: 10px;
    padding-top: 10px;
  }
`;


const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;

const PaddingBottomEntitySearch = styled.div`
  margin-bottom: 20px;
  :last-child {
    margin-bottom: 0px;
  }
  // & .MuiPaper-elevation3 {
  //   box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%) inset, 0px 3px 4px 0px rgb(0 0 0 / 14%) inset,
  //     0px 1px 8px 0px rgb(0 0 0 / 12%) inset, 0px 3px 3px -2px rgb(0 0 0 / 20%),
  //     0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
  // }

  // & .MuiPaper-elevation2 {
  //   box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%) inset, 0px 2px 2px 0px rgb(0 0 0 / 14%) inset,
  //     0px 1px 5px 0px rgb(0 0 0 / 12%) inset, 0px 3px 1px -2px rgb(0 0 0 / 20%),
  //     0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  // }
`;
